import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sp-version',
  templateUrl: './sp-version.component.html',
  styleUrls: ['./sp-version.component.scss']
})
export class SpVersionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
